import { Type } from '@angular/core';

import { CapAlertsEnableModalComponent } from 'src/app/settings/components/integrations/component-integrations/cap-alerts/cap-alerts-enable-modal/cap-alerts-enable-modal.component';
import { CapAlertsComponent } from 'src/app/settings/components/integrations/component-integrations/cap-alerts/cap-alerts.component';

import { CapAlertsService } from '../component-integrations/cap-alerts/cap-alerts.service';
import { CompanyIntegrationComponentService } from '../models/integrations.types';

/** Feature wiring for company integrations (dialogs + lifecycle services). */
export interface CompanyIntegrationRegistryEntry {
  component?: Type<unknown>;
  enableComponent?: Type<unknown>;
  componentService?: Type<CompanyIntegrationComponentService>;
}

/**
 * Registers dialog components and component services by catalog id.
 * Kept beside the company service so the catalog stays metadata-only.
 */
export const COMPANY_INTEGRATION_REGISTRY: Record<
  string,
  CompanyIntegrationRegistryEntry
> = {
  'cap-alerts': {
    enableComponent: CapAlertsEnableModalComponent,
    component: CapAlertsComponent,
    componentService: CapAlertsService,
  },
};
